import { render } from "./stage3.vue?vue&type=template&id=e2307382&scoped=true"
import script from "./stage3.vue?vue&type=script&lang=js"
export * from "./stage3.vue?vue&type=script&lang=js"

import "./stage3.vue?vue&type=style&index=0&id=e2307382&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2307382"]])

export default __exports__